module.exports = __webpack_public_path__ + "2332bf091d06c1a0f99fc9555aa8c0cd.svg";